import { combineReducers } from 'redux';
import userReducer from './userReducer';

/**
 * Корневой редьюсер, объединяющий все редьюсеры приложения
 */
const rootReducer = combineReducers({
  user: userReducer,
  // Здесь можно добавить другие редьюсеры при необходимости
});

export default rootReducer; 